import React from 'react';
import { useTranslation } from 'react-i18next';
import OrderForm from './OrderForm';
import Styles from './styles.module.css';

export default function VendersDashboard() {
  const { t } = useTranslation();
  return (
    <div className={Styles.appContainer}>
      <section className={Styles.pageSection}>
        <h1 className={Styles.pageHeader}>{t('Vendor Dashboard')}</h1>
        <p className={Styles.pageIntro}>
          {t('Manage your orders and stay connected with the Krushiratna team. Use the form below to place fresh dairy orders quickly.')}
        </p>
        <div className={Styles.sectionCard}>
          <OrderForm />
        </div>
      </section>
    </div>
  );
}
